import { render } from "./searchClient.vue?vue&type=template&id=141d5a74&ts=true"
import script from "./searchClient.vue?vue&type=script&lang=ts"
export * from "./searchClient.vue?vue&type=script&lang=ts"

import "./searchClient.vue?vue&type=style&index=0&id=141d5a74&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__